(() => {
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const scenes = [...root.querySelectorAll('[data-scene]')];
    const stage = root.querySelector('[data-stage]');
    const transition = root.querySelector('.htt-garden__transition');
    const player = root.querySelector('[data-transition-player]');
    const modal = root.querySelector('[data-film-modal]');
    const film = modal.querySelector('video');
    const indicator = root.querySelector('[data-scene-indicator]');
    const history = [];
    let current = scenes.find(s => s.dataset.scene === root.dataset.startScene) || scenes[0];
    let busy = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    if (!current) return;
    scenes.forEach(s => s.classList.toggle('is-active', s === current));
    function updateIndicator() {
      const index = scenes.indexOf(current);
      indicator.textContent = `${String(index + 1).padStart(2, '0')} / ${current.querySelector('h1')?.textContent || 'GARDEN'}`;
    }
    updateIndicator();
    function finish(next, push) {
      if (push) history.push(current.dataset.scene);
      current.classList.remove('is-active');
      next.classList.add('is-active');
      current = next;
      updateIndicator();
      busy = false;
    }
    function go(id, push = true) {
      const next = scenes.find(s => s.dataset.scene === id);
      if (!next || next === current || busy) return;
      busy = true;
      const url = next.dataset.transitionVideo;
      if (!url || reduced.matches) { finish(next, push); return; }
      transition.classList.add('is-playing');
      player.src = url;
      player.currentTime = 0;
      let completed = false;
      function end() {
        if (completed) return;
        completed = true;
        player.pause();
        finish(next, push);
        transition.classList.remove('is-playing');
        player.removeAttribute('src');
        player.load();
      }
      player.onended = end;
      player.onerror = end;
      const timeout = setTimeout(end, 8000);
      player.onended = () => { clearTimeout(timeout); end(); };
      player.onerror = () => { clearTimeout(timeout); end(); };
      player.play().catch(() => { clearTimeout(timeout); end(); });
    }
    root.addEventListener('click', event => {
      const target = event.target.closest('[data-go-scene]');
      if (target) { event.preventDefault(); go(target.dataset.goScene); }
      if (event.target.closest('[data-back-scene]')) { const prev = history.pop(); if (prev) go(prev, false); }
      if (event.target.closest('[data-open-film]')) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (film) film.play().catch(() => {});
        modal.querySelector('[data-close-film]').focus();
      }
      if (event.target.closest('[data-close-film]')) closeFilm();
    });
    function closeFilm() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (film) { film.pause(); film.currentTime = 0; }
      root.querySelector('.is-active [data-open-film]')?.focus();
    }
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !modal.hidden) closeFilm();
    });
  }
  function boot() { document.querySelectorAll('[data-htt-garden]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
